import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'cc-ng1-menu-top'
})
export class Ng1MenuTopDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('menuTop', elementRef, injector);
  }
}
